// extracted by mini-css-extract-plugin
module.exports = {"addZone":"UserCharacters_addZone__3GAGx","characters":"UserCharacters_characters__32AJ9"};